module.exports = __webpack_public_path__ + "f83db1ff40065887e32f1c04ace946aa.png";